Monitoring.Views ||= {}

class Monitoring.Views.ResponseBlockView extends Backbone.View
  tagName: 'span'
  templateAppstoreDev: JST['backbone/templates/monitoring/social_contents/apple_app_store/developer_true']
  templateAppstoreUser: JST['backbone/templates/monitoring/social_contents/apple_app_store/developer_false_fixed']
  templateGoogleplayDev: JST['backbone/templates/monitoring/social_contents/google_play/google_play/gp_review_comment/social_content_owner_fixed']
  templateGoogleplayUser: JST['backbone/templates/monitoring/social_contents/google_play/google_play/gp_review_comment/social_content_user_fixed']
  initialize: (analysisUnit) =>
    @model = analysisUnit

  render: =>
    if @model.type() == "apple_app_store"
      if @model.isBrandContent()
        template = @templateAppstoreDev
      else
        template = @templateAppstoreUser
    else
      if @model.isBrandContent()
        template = @templateGoogleplayDev
      else
        template = @templateGoogleplayUser
    @$el.html(template(@model))
    @

  setRating: (starNumber) ->
    for rating in _.range(1, starNumber  + 1)
      @$el.find("#star#{rating}").prop('checked', true)
